import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { SybaseLinkedService } from 'app/model/linkedservice/sybase.linkedservice';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SybaseLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                server: '*',
                database: '*',
                authenticationType: '*',
                username: '*',
                password: 'secret',
                encryptedCredential: '*'
            }
        }
    }
})
export class SybaseLinkedServiceAdapter extends LinkedServiceAdapter<SybaseLinkedService> {
    protected modelConstructor(): new () => SybaseLinkedService {
        return SybaseLinkedService;
    }

    protected model(): IModel {
        return SybaseLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: SybaseLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.SybaseLinkedService;

        properties.type = Metamodel.modelFor(SybaseLinkedService).name;
        properties.typeProperties = {
            server: linkedService.server,
            database: linkedService.database,
            authenticationType: linkedService.authenticationType,
            username: linkedService.userName,
            password: passwordOrAKVtoSecretBase(linkedService.password, this.context)
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: SybaseLinkedService): Promise<SybaseLinkedService> {
        const prop = linkedServiceResource.properties as Model.SybaseLinkedService;
        linkedService.server = prop.typeProperties.server;
        linkedService.database = prop.typeProperties.database;
        linkedService.authenticationType = prop.typeProperties.authenticationType;
        linkedService.userName = prop.typeProperties.username;
        linkedService.password = secretBaseToPasswordOrAKV(prop.typeProperties.password, true, this.context);

        return linkedService;
    }
}
